import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";

import Main from "../../Content/Main";

export const ProtectedMainRouteContent = ({ loggedIn }) => {
  const location = useLocation();
  if (!loggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Main />;
};

ProtectedMainRouteContent.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  loggedIn: state.oauth.loggedIn,
});

const ProtectedMainRoute = connect(mapStateToProps)(ProtectedMainRouteContent);

export default ProtectedMainRoute;
